<script setup lang="ts">
import type { ComboboxGroupProps } from 'reka-ui'
import { cn } from '@/shadcn/lib/utils'
import { ComboboxGroup, ComboboxLabel } from 'reka-ui'
import { computed, type HTMLAttributes } from 'vue'

const props = defineProps<ComboboxGroupProps & {
  class?: HTMLAttributes['class']
  heading?: string
}>()

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props

  return delegated
})
</script>

<template>
  <ComboboxGroup
    data-slot="combobox-group"
    v-bind="delegatedProps"
    :class="cn('tw:overflow-hidden tw:p-1 tw:text-foreground', props.class)"
  >
    <ComboboxLabel v-if="heading" class="tw:px-2 tw:py-1.5 tw:text-xs tw:font-medium tw:text-muted-foreground">
      {{ heading }}
    </ComboboxLabel>
    <slot />
  </ComboboxGroup>
</template>
